
import {
    SET_KENSHI,
    SET_KENSHI_ERROR,
    SET_KENSHI_LOADING,
  } from "../actionTypes";
  
  const initialState = {
    kenshi: [],
    kenshiError: null,
    kenshiLoading: false
  };
  
  const kenshiReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case SET_KENSHI:
        return {
          ...state,
          kenshi: payload,
        };
      case SET_KENSHI_ERROR:
        return {
          ...state,
          kenshiError: payload,
        };
  
      case SET_KENSHI_LOADING:
        return {
          ...state,
          kenshiLoading: payload,
        };
      default:
        return state;
    }
  };
  
  export default kenshiReducer;
  